/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import { HotspotServerContext } from './context/HotspotServerContext';
import CustomButton from '../../../../shared/forms/CustomButton';
import CustomInput from '../../../../shared/forms/CustomInput';

const AddHotspotServer = () => {
  const { loadingForm, onChange, formValue, onSubmit } = useContext(HotspotServerContext);
  const { base_station, ip_address, old_name, new_name } = formValue;
  const submitForm = () => {
    return base_station.length > 0 && ip_address.length > 0 && old_name.length > 0 && new_name.length > 0;
  };
  return (
    <div id="add-access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header shadow">
            <h4 className="modal-title update_asset">Hotspot Server</h4>
            <button type="button" className="btn btn-outline-info btn-circle btn-close" data-dismiss="modal">
              x
            </button>
          </div>
          <div className="modal-body detail mb-4 p-0">
            <form
              className="col-md-12 p-0"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <div className="d-flex">
                <div className="form-group col-6">
                  <label className="m-0 p-0 copy-font" htmlFor="customerName">
                    Basestation
                  </label>
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="base_station"
                    value={base_station}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="base station"
                    type="text"
                    id="customerName"
                  />
                </div>
                <div className="form-group col-6">
                  <label className="m-0 p-0 copy-font" htmlFor="customerEmail">
                    IP Address
                  </label>

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="ip_address"
                    value={ip_address}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="IP ADDRESS"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="d-flex">
                <div className="form-group col-6">
                  <label className="m-0 p-0 copy-font" htmlFor="router_id">
                    Device Type
                  </label>

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="old_name"
                    value={old_name}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Old Name"
                    type="text"
                    id="router_id"
                  />
                </div>
                <div className="form-group col-6">
                  <label className="m-0 p-0 copy-font" htmlFor="radioMACID">
                    New Name
                  </label>

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="new_name"
                    value={new_name}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="New Name"
                    type="text"
                    id="radioMACID"
                  />
                </div>
              </div>

              <div className="text-center mt-3">
                {loadingForm ? (
                  <CustomButton classname="btn btn-green px-3" name="Adding" disabled={loadingForm} />
                ) : (
                  <CustomButton classname="btn btn-green px-3" name="Add" disabled={!submitForm()} />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHotspotServer;
